// extracted by mini-css-extract-plugin
module.exports = {"speaker":"Paragraphs_speaker__1kdz6","unselectable":"Paragraphs_unselectable__3k2Ob","highlightedWord":"Paragraphs_highlightedWord__3mJtY"};